import React from "react";
import { Modal, Box, Typography, CircularProgress, Paper } from "@mui/material";

const LoadingModal = ({ open, message }) => {
  return (
    <Modal open={open}>
      <Box sx={styles.container}>
        <Paper sx={styles.paper}>
          <CircularProgress color="inherit" />
          <Typography variant="h6" sx={{ mt: 2 }}>
            {message}
          </Typography>
        </Paper>
      </Box>
    </Modal>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
  paper: {
    padding: "30px 40px",
    backgroundColor: "#303030",
    color: "#fff",
    borderRadius: "10px",
    textAlign: "center",
  },
};

export default LoadingModal;
